import { createReducer } from '@reduxjs/toolkit';

import {
  setMetaFlow,
  setFerryGrouping,
  saveVehicleFormValues,
  saveJourneyFormValues,
  setJourneyDates,
  setJourneys,
  setSegmentStop,
  saveReservationId,
  savePassengerFormValues,
  saveServiceFormValues,
  saveOriginalServiceFormValues,
  saveAccommodationSearchFormValues,
  saveAccommodationSearchResults,
  setAccommodationCurrentProvider,
  setAccommodationCurrentRoom,
  setAccommodationCurrentTotalPrice,
  setBookingTenant,
} from 'redux/actions/ui/sealink';

const validSteps = ['/ferry', '/accommodation', '/experiences', '/checkout'];
const { pathname } = window.location;
const stepPath = validSteps.find((step) => pathname.includes(step));
const savedFerryGrouping = ecom.redux_initial_state.sealink?.ferryGrouping;
const bookingTenant = ecom.redux_initial_state.sealink?.bookingTenant;
let ferryGrouping = [];

if (savedFerryGrouping) {
  ferryGrouping = [
    {
      values: savedFerryGrouping,
    },
  ];
}

export const initialState = {
  metaFlow: {
    currentStep: stepPath || '/',
  },
  bookingTenant,
  ferryGrouping,
  accommodationGrouping: [],
  experienceGrouping: [],
};

export default createReducer(initialState, {
  [setMetaFlow]: (state, action) => {
    state.metaFlow = action.payload;
  },
  [setFerryGrouping]: (state, action) => {
    state.ferryGrouping = action.payload;
  },
  [saveVehicleFormValues]: (state, action) => {
    const currentGroupingIndex = 0;
    const { takingVehicle } = state.ferryGrouping[
      currentGroupingIndex
    ].values.journeyForm;
    state.ferryGrouping[currentGroupingIndex].values.vehicleForm = {
      takingVehicle,
      ...action.payload,
    };
  },
  [saveJourneyFormValues]: (state, action) => {
    const existingFerryGrouping = state.ferryGrouping[0]?.values || {};

    state.ferryGrouping = [
      {
        values: {
          ...existingFerryGrouping,
          journeyForm: action.payload,
        },
      },
    ];
  },
  [setJourneyDates]: (state, action) => {
    const currentGroupingIndex = 0;
    state.ferryGrouping[currentGroupingIndex].values.journeyForm.journeyDates =
      action.payload;
  },
  [setJourneys]: (state, action) => {
    const currentGroupingIndex = 0;
    state.ferryGrouping[currentGroupingIndex].values.journeyForm.journeys =
      action.payload;
  },
  [setSegmentStop]: (state, action) => {
    const currentGroupingIndex = 0;

    const { journeyIndex, segmentId, segmentStop } = action.payload;

    const journey =
      state.ferryGrouping[currentGroupingIndex].values.journeyForm.journeys[
        journeyIndex
      ];

    journey.segmentStops[segmentId] = segmentStop;
  },
  [saveReservationId]: (state, action) => {
    const currentGroupingIndex = 0;
    const { journeyIndex, segmentId, reservationId } = action.payload;

    const journey =
      state.ferryGrouping[currentGroupingIndex].values.journeyForm.journeys[
        journeyIndex
      ];

    if (!journey.segmentReservationIds) {
      journey.segmentReservationIds = {};
    }
    journey.segmentReservationIds[segmentId] = reservationId;
  },
  [savePassengerFormValues]: (state, action) => {
    const { groupingIndex, passengers } = action.payload;
    state.ferryGrouping[groupingIndex].values.passengerForm = { passengers };
  },
  [saveServiceFormValues]: (state, action) => {
    const currentGroupingIndex = 0;
    state.ferryGrouping[currentGroupingIndex].values.serviceForm =
      action.payload;
  },

  /*
  Need to keep the original form data for service form, otherwise the page breaks if the user
  goes back to the service form with a booking without shuttle(no vehicle and no shuttle transport)
  */
  [saveOriginalServiceFormValues]: (state, action) => {
    const currentGrouping = state.ferryGrouping[0];

    if (currentGrouping) {
      currentGrouping.values.originalServiceForm = action.payload;
    }
  },
  [saveAccommodationSearchFormValues]: (state, action) => {
    state.accommodationFlow = {
      ...state.accommodationFlow,
      searchParams: action.payload,
    };
  },
  [saveAccommodationSearchResults]: (state, action) => {
    state.accommodationFlow = {
      ...state.accommodationFlow,
      searchResults: action.payload,
    };
  },
  [setAccommodationCurrentProvider]: (state, action) => {
    state.accommodationFlow = {
      ...state.accommodationFlow,
      currentProvider: action.payload,
    };
  },
  [setAccommodationCurrentRoom]: (state, action) => {
    state.accommodationFlow = {
      ...state.accommodationFlow,
      currentRoom: action.payload,
    };
  },
  [setAccommodationCurrentRoom]: (state, action) => {
    state.accommodationFlow = {
      ...state.accommodationFlow,
      currentRoom: action.payload,
    };
  },
  [setAccommodationCurrentTotalPrice]: (state, action) => {
    state.accommodationFlow = {
      ...state.accommodationFlow,
      currentTotalPrice: action.payload,
    };
  },
  [setBookingTenant]: (state, action) => {
    state.bookingTenant = action.payload;
  },
});
